<template>
  <v-card :flat="isFlat">
    <vue-perfect-scrollbar>
      <v-card-text class="customer-dues pa-0">
        <v-container grid-list-lg fluid>
          <v-layout row wrap>
            <table-skeleton :columns="4" :has-headers="true" v-if="loading">
            </table-skeleton>
            <v-data-table
              v-else
              :headers="headers"
              hide-actions
              class="datatable-dues-v2 w-100"
              no-data-text="No se encontraron datos"
              :items="data"
              :pagination.sync="sorting">
              <template slot="headers" slot-scope="props">
                <th v-for="(header, index) in props.headers" :key="`header-${index}`" :class="{ [header.class]: true }">
                  <v-icon class="mr-2 k-orange-linear-text">{{ header.icon }}</v-icon>
                  <span>
                    {{ header.text }}
                  </span>
                </th>
              </template>
              <template slot="items" slot-scope="props">
                <tr>
                  <td v-if="$auth.user().company_id === 56746521">
                    {{ props.item.descrip }}
                  </td>
                  <td v-else>
                    {{ props.item.name }}
                  </td>
                  <td>
                    {{ getCustomerField('id', props.item.workflow_status_id, 'status') }}
                  </td>
                  <td>
                    {{ props.item.reference }}
                  </td>
                  <td>
                    {{ props.item.due_date | formatDate }}
                  </td>
                  <td>
                    {{ props.item.invoiced_balance | formatNumber }}
                  </td>
                  <td>
                    {{ props.item.due_balance | formatNumber }}
                  </td>
                  <td v-if="$auth.user().company_id === 83806105">
                    {{ props.item.total | formatNumber }}
                  </td>
                  <td class="text-xs-right">
                    <v-tooltip top>
                      Crear gestion
                      <v-btn slot="activator" flat icon @click="props.expanded = !props.expanded">
                        <v-icon small>fa-plus</v-icon>
                      </v-btn>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props" colspan="6">
                <div >
                  <v-card>
                    <v-container class="mx-auto d-block w-100">
                      <v-layout>
                        <h3>Crear gestion</h3>
                      </v-layout>
                      <v-layout>
                        <v-flex :sm="(!form.status || [32, 34, 26, 10].includes(form.status)) ? 12 : 6">
                          <v-select
                            v-model="form.status"
                            :items="statuses"
                            v-validate="'required'"
                            item-text="status"
                            item-value="value"
                            :data-vv-name="'Estado'"
                            :data-vv-as="'Estado'"
                            :error-messages="errors.collect('Estado')"
                            label="Estado"
                            color="black">
                          </v-select>
                        </v-flex>
                        <v-flex sm="6" v-if="form.status && [8, 44, 46, 35].includes(form.status)">
                          <v-menu
                            v-if="[8, 44].includes(form.status)"
                            ref="from"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.date"
                            transition="scale-transition"
                            min-width="290px"
                            lazy
                            offset-y
                            full-width>
                              <v-text-field
                                slot="activator"
                                v-model="form.date"
                                append-icon="event"
                                :label="dateLabel"
                                readonly
                                color="black">
                              </v-text-field>
                              <v-date-picker
                                v-model="form.date"
                                @input="$refs.from.save(form.date)"
                                :allowed-dates="getAllowedDates"
                                locale="es"
                                color="k-orange-linear">
                              </v-date-picker>
                          </v-menu>
                          <v-select
                            v-if="[46, 35].includes(form.status)"
                            v-model="form.sub_status_id"
                            :items="getSubStatusesByStatus(form.status)"
                            v-validate="'required'"
                            item-text="name"
                            item-value="id"
                            :data-vv-name="'Sub estado'"
                            :data-vv-as="'Sub estado'"
                            :error-messages="errors.collect('Sub estado')"
                            label="Sub estado"
                            color="black">
                          </v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="form.descrip"
                            v-validate="'max:10000'"
                            class="comentario-dues-v2"
                            data-vv-name="Comentario"
                            data-vv-as="comentario"
                            :error-messages="errors.collect('Comentario')"
                            label="Comentario"
                            color="black"
                          />
                        </v-flex>
                      </v-layout>
                      <v-card-actions>
                        <v-layout>
                          <v-flex class="px-0 text-xs-right xs12" >
                            <v-btn flat color="black" @click="cancelExpand(props)">
                              CANCELAR
                            </v-btn>
                            <v-btn class="k-orange-linear-text" flat @click="save(props)">
                              Guardar
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-container>
                  </v-card>
                  <v-card>
                    <v-container class="mx-auto d-block w-100">
                      <v-layout>
                        <h3>Detalle</h3>
                      </v-layout>
                      <due-details
                        v-if="Object.keys(getDetail(props.item.details).detailed).length > 6"
                        :details="getDetail(props.item.details).detailed">
                      </due-details>
                      <v-layout row wrap v-else>
                        <table class="sub-table">
                          <thead>
                            <tr>
                              <th v-for="(head, idx) in Object.keys(getDetail(props.item.details).detailed)" :key="`sub-table-${idx}`">
                                {{ head }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td v-for="(key, i) in Object.keys(getDetail(props.item.details).detailed)" :key="`detail-column-${i}`">
                                <ul>
                                  <li class="mb-2" v-for="(item, itemIndex) in getDetail(props.item.details).detailed[key]" :key="`detail-item-${itemIndex}`">
                                    <span v-if="item.type === 'amount'">
                                      {{ item.value | formatNumber }}
                                    </span>
                                    <span v-else-if="item.type === 'date'">
                                      {{ item.value | formatDate }}
                                    </span>
                                    <span v-else>
                                      {{ item.value }}
                                    </span>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </v-layout>
                    </v-container>
                  </v-card>
                </div>
              </template>
            </v-data-table>
          </v-layout>
        </v-container>
      </v-card-text>
    </vue-perfect-scrollbar>
  </v-card>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import StatusMixin from '@/mixins/status';
import TableSkeleton from '@/components/global/skeletons/TableSkeleton';
import DueDetails from './DueDetails';

const form = {
  status: '',
  date: '',
  sub_status_id: '',
  descrip: '',
};

export default {
  inject: ['$validator'],
  mixins: [StatusMixin],
  components: {
    VuePerfectScrollbar,
    TableSkeleton,
    DueDetails,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: 'tab-4',
    },
    isFlat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      statuses: [
        {
          value: 8,
          status: 'Compromiso',
        },
        {
          value: 35,
          status: 'Sin compromiso',
        },
        {
          value: 44,
          status: 'Intención de pago',
        },
        {
          value: 32,
          status: 'Rechaza oferta',
        },
        {
          value: 34,
          status: 'Solicita refinanciamiento',
        },
        {
          value: 26,
          status: 'Cuenta pagada',
        },
        {
          value: 10,
          status: 'Desconoce deuda',
        },
        {
          value: 46,
          status: 'Alternativa de pago',
        },
      ],
      form,
      sorting: {
        sortBy: 'due_date',
        descending: true,
        rowsPerPage: -1,
        page: 1,
        totalItems: 0,
      },
      due: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      getSubStatusesByStatus: 'getSubStatusesByStatus',
    }),
    dateLabel() {
      if (this.form.status) {
        let text = '';
        if (this.form.status === 8) {
          text = 'Fecha de compromiso';
        }
        if (this.form.status === 46) {
          text = 'Fecha de alternativa';
        }
        return text;
      }
      return '';
    },
    headers() {
      const items = [
        {
          text: 'Nombre',
          icon: 'fa-tag',
          class: 'text-xs-left',
          value: 'name',
        },
        {
          text: 'status',
          icon: 'fa-clipboard-list',
          class: 'text-xs-left',
          value: 'workflow_status_id',
        },
        {
          text: 'Referencia',
          icon: 'fa-calendar-alt',
          class: 'text-xs-left',
          value: 'reference',
        },
        {
          text: 'F. vencimiento',
          icon: 'fa-file-invoice',
          class: 'text-xs-left',
          value: 'due_date',
        },
        {
          text: 'Saldo facturado',
          icon: 'fa-hand-holding-usd',
          class: 'text-xs-left',
          value: 'invoiced_balance',
        },
        {
          text: 'Deuda',
          icon: 'fa-list',
          class: 'text-xs-left',
          value: 'due_balance',
        },
        {
          text: 'Acciones',
          icon: '',
          class: 'text-xs-right',
          value: 'id',
        },
      ];
      if (this.$auth.user().company_id === 83806105) { // Scotiabank PE
        items.splice(items.length - 1, 0, {
          text: 'Total',
          icon: 'fa-file-invoice-dollar',
          class: 'text-xs-left',
          value: 'total',
        });
      }
      return items;
    },
  },
  filters: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    formatNumber(value) {
      return new Intl.NumberFormat('es-VE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value);
    },
  },
  methods: {
    fetchDues() {
      this.data = [];
      this.loading = true;
      this.axios.get(`customers/${this.customer.id}/dues-v2`).then(({ data }) => {
        this.data = data.dues;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    cancelExpand(prop) {
      prop.expanded = false;
      this.form.status = '';
      this.form.date = '';
      this.form.sub_status_id = '';
      this.form.descrip = '';
    },
    save(prop) {
      let ns;
      if (Object.keys(this.$store.state.dialer.notification || {}).length) {
        ns = this.$store.state.dialer.notification;
      } else if (Object.keys(this.$store.state.dialerV2.currentCall || {}).length) {
        ns = this.$store.state.dialerV2.currentCall;
      }
      if (ns) {
        // Comentario opcional
        const validations = [
          this.$validator.validate('Estado'),
          this.$validator.validate('Comentario'),
        ];
        if (this.form.status && [46, 35].includes(this.form.status)) {
          validations.push(this.$validator.validate('Sub estado'));
        }
        Promise.all(validations).then((results) => {
          if (!results.every(Boolean)) {
            return;
          }
          const payload = {
            status: this.form.status,
            phone: ns.to,
            ...[8, 44].includes(this.form.status) && {
              date: this.form.date,
            },
            ...[46, 35].includes(this.form.status) && {
              sub_status_id: this.form.sub_status_id,
            },
          };
          const trimmedDescrip = (this.form.descrip || '').trim();
          if (trimmedDescrip) {
            payload.descrip = trimmedDescrip;
          }
          this.axios.post(`dues/create-ns/${prop.item.id}`, payload).then(({ data }) => {
            this.cancelExpand(prop);
            this.$emit('ns-created', data.notificationSchedule);
          });
        });
      }
    },
    getAllowedDates(val) {
      const date = moment.tz(val, 'YYYY-MM-DD', 'America/Santiago');
      return moment.tz('America/Santiago').diff(date, 'days') <= 0;
    },
    parseJsonWithNone(jsonString) {
      try {
        // Primero intenta parsear directamente
        return JSON.parse(jsonString);
      } catch (e) {
        // Si falla, reemplaza None por "" y vuelve a intentar
        const cleanedString = jsonString.replace(/\bNone\b/g, '""');
        return JSON.parse(cleanedString);
      }
    },
    getDetail(detail) {
      return {
        details: this.parseJsonWithNone(detail || '[]'),
        detailed: _.mapValues(_.groupBy(_.flatten(this.parseJsonWithNone(detail || '[]')), 'name'),
          details => details.map(detail => _.omit(detail, 'name'))),
      };
    },
  },
  watch: {
    tab: {
      immediate: true,
      handler(value) {
        if (this.customer && value === 'tab-4') {
          this.fetchDues();
        }
      }
    },
  },
};
</script>
<style scoped>
  .customer-dues {
    height: 392px;
  }
  /* .customer-dues >>> .datatable.table {
    table-layout: fixed;
  } */
  .customer-dues .datatable-dues-v2 >>> .datatable.table th, .customer-dues .datatable-dues-v2 >>> .datatable.table td {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .customer-dues >>> .datatable.table td {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    padding-right: 0px !important;
    word-break: break-all;
    white-space: normal !important;
  }
  .customer-dues >>> table.table tbody tr:first-child {
    border-top: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody tr:not(:last-child):not(.datatable__expand-row) {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody tr.datatable__expand-row .datatable__expand-col {
    padding-left: 0 !important;
  }
  .customer-dues >>> table.table tbody tr.datatable__expand-row .datatable__expand-col--expanded .datatable__expand-content {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .sub-table {
    width: 100%;
  }
  .sub-table th {
    text-align: left;
  }
  .sub-table td {
    padding: 16px !important;
  }
  .sub-table td ul {
    padding: 0;
    list-style: none;
  }

  /* Comentario: input de una línea; el texto largo no se sale, scroll horizontal dentro */
  .comentario-dues-v2 >>> .input-group__input {
    min-width: 0;
    overflow: hidden;
  }
  .comentario-dues-v2 >>> input {
    overflow-x: auto !important;
    overflow-y: hidden !important;
    text-overflow: clip !important;
    white-space: nowrap !important;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerDuesV2.vue